export const shouldMealValueUpdate = (prevProps, props) => {
  if (props.formValues) {
    const {
      ServingDate,
      TotalParticipation,
      MealType,
      Site,
    } = props.formValues;

    // If the Serving Date, Site, MealType or Total Participation value change,
    // the endpoint for calculating meal values needs to be hit.
    // This should only happen when ServingDate, state.site.value, and MealType have a value.
    // and the site does not have an ISP of 0
    if (Site && ServingDate && MealType !== null) {
      if (
        ServingDate !== prevProps.formValues.ServingDate ||
        hasSiteChanged(Site, prevProps.formValues.Site) ||
        MealType !== prevProps.formValues.MealType ||
        TotalParticipation !== prevProps.formValues.TotalParticipation
      ) {
        return true;
      }
    } else {
      return false;
    }
  }
};

export const formatSites = payload => {
  let sites = [];
  let primarySites = {};
  payload.forEach(function(site) {
    sites.push({
      value: site.SiteId,
      text: `${site.SiteId} ${site.Description}`,
    });
    primarySites[site.SiteId] = site.PrimarySiteId;
  });
  return { sites, primarySites };
};

// Make the SitesComponent only display sites which are CEP.
// @sites will come from the back end
export const siteFilter = sites => site =>
  sites.map(s => s.value).includes(site.value);

// Check to see if the site value is different from the last site value
// Or if site now has a value and previously site itself was null
const hasSiteChanged = (site, prevSite) => {
  const newSite = site;
  const previousSite = prevSite;

  if ((newSite && !previousSite) || newSite !== previousSite) {
    return true;
  } else {
    return false;
  }
};

export function getReimbursableItem(reimbursableItem, reimbursableItems) {
  if (reimbursableItem) {
    return reimbursableItem;
  } else {
    if (reimbursableItems.length > 0) {
      return reimbursableItems[0].value;
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/cepbulkprocessing/helpers/GenericHelpers.js